import React from "react";

function Leo() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.159 496.159"
      enableBackground="new 0 0 496.159 496.159"
    >
      <path
        fill="#F2B12F"
        d="M248.083,0.003C111.071,0.003,0,111.063,0,248.085c0,137.001,111.07,248.071,248.083,248.071
	c137.006,0,248.076-111.07,248.076-248.071C496.159,111.063,385.089,0.003,248.083,0.003z"
      />
      <path
        fill="#7A582B"
        d="M398.941,294.253l36.136,1.853c-14.825-48.181-51.887-44.475-51.887-44.475l38.915-37.988
	c-39.842-1.853-49.107-25.943-49.107-25.943l20.384-22.238c-2.78-7.412-31.503-11.118-31.503-11.118
	c4.633-4.633,3.707-26.87,3.707-26.87c-11.119,1.854-37.062-3.707-37.062-3.707c5.559-8.338,18.531-6.485,18.531-6.485
	c-20.384-22.237-64.859-5.559-64.859-5.559c-1.236-13.282,4.325-20.693,4.325-20.693c-21.002-5.56-33.356,16.06-33.356,16.06
	l-6.794-21.001l-3.706,21.001c-11.119-2.471-25.943-26.561-25.943-26.561c-11.119,9.884,3.088,38.916,3.088,38.916
	c-27.797-24.708-62.389-14.208-62.389-14.208c0,16.06,25.944,37.681,25.944,37.681c-23.472-19.15-67.948-9.266-67.948-9.266
	c4.942,17.295,16.678,22.237,16.678,22.237l-42.005,58.68c-39.534,21.62-27.179,72.891-27.179,72.891
	c16.678-21.62,42.815-12.973,42.815-12.973c-7.219,4.942-27.991,9.884-27.991,9.884c6.177,2.472,13.589,5.56,13.589,5.56
	c-22.855,8.03-22.237,37.063-22.237,37.063c11.118-4.324,36.639-0.618,36.639-0.618c-6.601-0.618-20.578,15.442-20.578,15.442
	c8.03,4.324,30.267,6.177,30.267,6.177c-21.002,12.973-12.972,29.65-12.972,29.65c10.501-5.56,27.797-8.647,27.797-8.647
	c11.736,1.234,19.149,3.706,19.149,3.706c0,16.678,11.119,32.12,11.119,32.12c0-12.972,11.737-14.207,11.737-14.207
	c3.088,19.767,11.736,17.296,11.736,17.296c1.235-9.266,12.354-8.03,12.354-8.03c-2.471,1.853-4.016,8.338-4.016,8.338
	c24.091,6.486,45.401-8.338,45.401-8.338l-0.926,15.751c0-8.339,16.679-7.413,16.679-7.413c12.044,10.192,34.282,4.634,34.282,4.634
	c-10.192-4.634-0.927-16.679-0.927-16.679c29.65,16.679,52.814-1.853,52.814-1.853c-10.192,0-20.384-8.34-20.384-8.34l50.961,1.854
	l-25.943-15.751c16.678,7.412,41.694-7.413,41.694-7.413l-18.53-8.339c9.265-7.412,29.649,1.854,29.649,1.854
	c0.927-15.752-12.972-32.43-12.972-32.43c15.752,2.779,27.796,14.825,27.796,14.825
	C419.325,303.519,398.941,294.253,398.941,294.253z"
      />
      <path
        fill="#D6953E"
        d="M328.513,203.984c10.954-25.878-28.438-65.434-85.661-52.739
	c-57.222-12.694-98.714,26.861-87.762,52.739c3.415,8.066-17.117,54.272,8.553,82.144c5.622,6.103,28.21,70.716,28.21,70.716
	c0.79,1.381,25.19,6.627,48.714,7.004c0,0.009,0,0.023,0,0.023c0.411-0.001,0.823-0.007,1.234-0.011
	c0.411,0.004,0.824,0.01,1.234,0.011c0,0,0-0.015,0-0.023c23.524-0.377,47.925-5.623,48.714-7.004c0,0,22.59-64.613,28.211-70.716
	C345.631,258.256,325.099,212.05,328.513,203.984z"
      />
      <path
        fill="#C18236"
        d="M242.852,151.245c-57.222-12.694-98.714,26.861-87.762,52.739
	c3.415,8.066-17.117,54.272,8.553,82.144c5.622,6.103,28.21,70.716,28.21,70.716c0.79,1.381,25.19,6.627,48.714,7.004
	c0,0.009,0,0.023,0,0.023c0.411-0.001,0.823-0.007,1.234-0.011c0.411,0.004,0.824,0.01,1.234,0.011c0,0,0-0.015,0-0.023
	L242.852,151.245z"
      />
      <path
        fill="#D6953E"
        d="M255.313,361.594l-12.461-8.826l-12.716,8.901l-36.815-4.826
	c3.339,5.845,20.203,24.079,20.203,24.079c12.828,15.134,45.832,14.034,59.74,0c0,0,16.864-18.234,20.203-24.079L255.313,361.594z"
      />
      <path
        fill="#BC7928"
        d="M280.533,283.009c-16.379-13.906-16.29-45.451-32.789-53.355c-1.579-0.758-7.148-0.796-8.644-0.104
	c-16.458,7.605-16.557,39.491-33.01,53.46c-29.153,24.754-38.872,53.174-16.501,75.359c9.91,9.829,43.455,12.377,43.455,12.377
	s8.906-10.815,9.086-10.863c0.165,0.044,2.2,0.044,2.364,0c0.181,0.048,9.085,10.863,9.085,10.863s33.546-2.548,43.456-12.377
	C319.405,336.183,309.686,307.763,280.533,283.009z"
      />
      <path
        fill="#D6953E"
        d="M277.639,288.567c-15.106-12.825-15.023-54.343-30.24-61.634c-1.457-0.698-6.592-0.733-7.972-0.097
	c-15.179,7.015-15.27,48.847-30.442,61.73c-26.887,22.828-35.849,49.039-15.219,69.5c9.139,9.063,40.076,11.414,40.076,11.414
	s8.213-9.975,8.379-10.02c0.151,0.041,2.029,0.041,2.181,0c0.167,0.045,8.379,10.02,8.379,10.02s30.937-2.351,40.077-11.414
	C313.488,337.606,304.525,311.395,277.639,288.567z"
      />
      <path
        fill="#C18236"
        d="M242.852,226.239c-1.638-0.016-2.735,0.279-3.425,0.598c-15.179,7.015-15.27,48.847-30.442,61.73
	c-26.887,22.828-35.849,49.039-15.219,69.5c9.139,9.063,40.076,11.414,40.076,11.414s8.213-9.975,8.379-10.02
	c0.079,0.021,0.627,0.031,1.156,0.03C243.862,359.491,242.852,226.239,242.852,226.239z"
      />
      <g>
        <path
          fill="#3F2308"
          d="M278.084,321.127c-16.492-8.386-33.68-10.519-34.403-10.604c-0.098-0.014-0.189,0.021-0.287,0.024
		c-0.096-0.004-0.188-0.038-0.286-0.024c-0.723,0.085-17.912,2.218-34.403,10.604c-0.542,0.276-0.892,0.824-0.913,1.433
		c-0.02,0.607,0.292,1.179,0.814,1.49l33.845,20.175c0.264,0.157,0.559,0.235,0.854,0.235c0.03,0,0.06-0.009,0.088-0.011
		c0.03,0.002,0.059,0.011,0.09,0.011c0.295,0,0.591-0.078,0.855-0.235l33.845-20.175c0.521-0.312,0.833-0.883,0.814-1.49
		C278.976,321.952,278.627,321.404,278.084,321.127z"
        />
        <path
          fill="#3F2308"
          d="M279.202,365.409c-0.396-0.902-1.449-1.312-2.35-0.915c-11.653,5.127-20.291,5.79-25.677,1.966
		c-4.451-3.159-5.81-8.87-6.199-12.757c0.185-2.452,0.034-11.09,0.016-11.285c-0.087-0.914-0.853-1.595-1.746-1.606
		c-0.005,0-0.01-0.002-0.016-0.003c-0.98-0.089-1.841,0.651-1.922,1.634c-0.016,0.196-0.144,8.851,0.077,11.319
		c-0.334,3.851-1.607,9.471-5.971,12.639c-5.362,3.891-14.099,3.25-25.971-1.909c-0.904-0.395-1.955,0.021-2.346,0.925
		c-0.394,0.903,0.021,1.954,0.924,2.347c7.199,3.128,13.436,4.693,18.666,4.693c4.295,0,7.912-1.056,10.822-3.169
		c2.816-2.044,4.593-4.808,5.713-7.625c1.163,2.851,2.991,5.646,5.872,7.696c2.902,2.065,6.477,3.099,10.699,3.099
		c5.199,0,11.38-1.566,18.495-4.697C279.189,367.363,279.599,366.31,279.202,365.409z"
        />
      </g>
      <g>
        <path
          fill="#282727"
          d="M173.911,208.384c12.468,46.939,50.606,9.534,50.606,9.534
		C202.698,223.052,173.911,208.384,173.911,208.384z"
        />
        <path
          fill="#282727"
          d="M261.654,217.918c0,0,38.138,37.405,50.606-9.534C312.261,208.384,283.473,223.052,261.654,217.918z
		"
        />
      </g>
      <path
        fill="#6D4D25"
        d="M236.435,207.65c-0.55-2.2-2.75-3.851-2.75-3.851s-7.701,5.318-13.202,5.501
	c-10.339,0.345-24.937-4.033-34.288-5.501c-9.351-1.467-16.319,0-16.319,0s14.486,21.82,54.641,15.586
	c5.429-0.844,8.067-4.034,10.359-7.06C234.877,212.326,236.986,209.85,236.435,207.65z"
      />
      <path
        fill="#7A582B"
        d="M299.975,203.799c-9.351,1.468-23.949,5.846-34.288,5.501c-5.5-0.183-13.202-5.501-13.202-5.501
	s-2.2,1.65-2.75,3.851s1.559,4.676,1.559,4.676c2.292,3.025,4.93,6.216,10.359,7.06c40.155,6.234,54.641-15.586,54.641-15.586
	S309.327,202.332,299.975,203.799z"
      />
      <path
        fill="#D6953E"
        d="M154.794,162.576c-18.826-14.1-43.06-13.548-54.13,1.233c-11.07,14.78-4.783,38.191,14.044,52.29
	C133.534,230.2,173.62,176.676,154.794,162.576z"
      />
      <path
        fill="#C98431"
        d="M162.791,185.09c-14.671-16.132-35.12-24.449-45.675-18.578c-10.555,5.87-7.216,23.706,7.456,39.838
	S177.464,201.222,162.791,185.09z"
      />
      <path
        fill="#D6953E"
        d="M385.22,163.809c-11.069-14.781-35.304-15.333-54.129-1.233
	c-18.826,14.101,21.26,67.624,40.086,53.523C390.003,202,396.29,178.589,385.22,163.809z"
      />
      <path
        fill="#C98431"
        d="M374.918,170.547c-5.87-10.555-23.706-7.216-39.838,7.456s5.128,52.892,21.26,38.219
	C372.472,201.551,380.79,181.102,374.918,170.547z"
      />
      <g>
        <path
          fill="#7A582B"
          d="M351.088,191.13c-5.039-2.063-14.349-17.636-14.349-17.636l22.825-3.075
		c-11.118-14.354-55.595-14.257-55.595-14.257c12.244,15.584,27.98,68.96,27.98,68.96c6.259,3.868,10.151,8.729,10.151,8.729
		c5.676-7.479-0.81-25.166-0.81-25.166l9.364-5.316l-10.38-8.17C340.274,195.2,356.127,193.192,351.088,191.13z"
        />
        <path
          fill="#7A582B"
          d="M274.586,136.141l-67.047,4.117l6.47,17.056l14.702,8.822l3.53-9.41c0,0,9.999,7.057,9.999,10.586
		l8.822-18.82l7.057,10.587l6.47-7.059l2.94,12.352l10.586-9.41L274.586,136.141z"
        />
        <path
          fill="#7A582B"
          d="M172.615,163.105c-14.123-4.762-50.211,8.168-50.211,8.168l10.445,11.566
		c-8.953,0.681-22.383,21.769-22.383,21.769c1.492,6.123,24.373,4.082,24.373,4.082l-10.445,6.803
		c4.974,8.164,25.614,7.213,25.614,7.213l14.675-25.58l11.439-17.689L172.615,163.105z"
        />
      </g>
      <g>
        <ellipse fill="#8C5519" cx="290.22" cy="328.39" rx="4.125" ry="2.475" />
        <ellipse fill="#8C5519" cx="276.2" cy="341.32" rx="4.125" ry="2.476" />
        <ellipse fill="#8C5519" cx="292.7" cy="348.74" rx="4.125" ry="2.475" />
        <ellipse fill="#8C5519" cx="196.71" cy="328.39" rx="4.125" ry="2.475" />
        <ellipse fill="#8C5519" cx="210.74" cy="341.32" rx="4.125" ry="2.476" />
        <ellipse fill="#8C5519" cx="194.24" cy="348.74" rx="4.125" ry="2.475" />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Leo;
